// Seed reference data for Dashboard Irbansus (Phase 1).
// Demo credentials are also seeded in the backend (MongoDB) on startup.
// This file is the UI-side reference used for the login page hint list.

export const ROLES = {
  ADMIN: "ADMIN",
  IRBAN: "IRBAN",
  DALNIS: "DALNIS",
  KETUA_TIM: "KETUA_TIM",
  ANGGOTA_TIM: "ANGGOTA_TIM",
};

export const ROLE_LABELS = {
  ADMIN: "Admin",
  IRBAN: "Irban",
  DALNIS: "Dalnis",
  KETUA_TIM: "Ketua Tim",
  ANGGOTA_TIM: "Anggota Tim",
};

export const ROLE_DESCRIPTIONS = {
  ADMIN: "Administrator — otoritas penuh setara Irban, dan dapat merangkap peran operasional apa pun.",
  IRBAN: "Inspektur Pembantu — otoritas penuh, persetujuan, penerima eskalasi.",
  DALNIS: "Pengendali Teknis — koordinasi, penugasan, pemantauan.",
  KETUA_TIM: "Ketua Tim — mengelola tugas tim, input verifikasi.",
  ANGGOTA_TIM: "Anggota Tim — input progres tugas yang ditugaskan.",
};

// Peran yang boleh mengisi tiap slot penugasan. ADMIN ikut di semua slot karena
// boleh merangkap; IRBAN tidak, ia penerima eskalasi bukan pelaksana.
export const PENGISI_SLOT = {
  DALNIS: [ROLES.DALNIS, ROLES.ADMIN],
  KETUA_TIM: [ROLES.KETUA_TIM, ROLES.ADMIN],
  ANGGOTA_TIM: [ROLES.ANGGOTA_TIM, ROLES.ADMIN],
};

export const SIDEBAR_ITEMS = [
  { label: "Dashboard", icon: "LayoutDashboard", path: "/dashboard" },
  { label: "Program Pengawasan 2026", icon: "FolderKanban", path: "/program" },
  { label: "Penugasan Tim", icon: "Users", path: "/penugasan" },
  { label: "Kendali Penugasan", icon: "CalendarRange", path: "/kendali-penugasan" },
  { label: "Progress Kegiatan", icon: "Activity", path: "/progress" },
  { label: "Telaahan Staff", icon: "FileSearch", path: "/telaahan-staff" },
  { label: "TL Riksus & AI", icon: "SearchCode", path: "/audit-investigasi" },
  { label: "Notifikasi", icon: "Bell", path: "/notifikasi" },
  { label: "Kegiatan Irbansus", icon: "ClipboardList", path: "/kegiatan-irbansus" },
  { label: "Pengaturan", icon: "Settings", path: "/pengaturan" },
];
